import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {BreadCrumbs} from "../../../components/open/pages";
import {ThinClassIcon, ThinPrintIcon, TomansIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GradeToString} from "../students/list";
import {thoseWhoPaidInFull} from "./fully-paid";
import {SelectClassModal} from "../classes/select-class-modal";
import {Link} from "react-router-dom";

export const AdminFinanceThoseWhoStillOweScreen = () => {
    const [classSelected, setClassSelected] = useState({
        id: 0,
        title: '',
    });
    const [classModal, setClassModal] = useState(false);
    const [data, setData] = useState({
        loaded: false,
        list: [] as thoseWhoPaidInFull[],
    });
    const fetchList = (classId:number) => {
        PostJSON(
            Apis.server + '/core/admins/finance/who-owe/list',
            {
                classId: classId,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: thoseWhoPaidInFull[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    list: d.list === null ? [] : d.list,
                    loaded: true,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "دانش‌آموزان بدهکار | نهال";
        fetchList(0);
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'امور مالی', url: '/admins/finance'},
                {title: 'دانش‌آموزان بدهکار', url: '/admins/finance/still-owe'},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>دانش‌آموزان بدهکار شهریه</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    <button onClick={() => setClassModal(true)}>
                                        <ThinClassIcon/>
                                        <span>{classSelected.id > 0 ? classSelected.title : 'همه کلاس‌ها'}</span>
                                    </button>
                                    <button onClick={() => window.open(`/print/admins/finance/sill-owe/${classSelected.id}`)}>
                                        <ThinPrintIcon/>
                                        <span>پرینت</span>
                                    </button>
                                </div>
                            </div>
                            <table className="table open-table table-stripped table-bordered table-hover"
                                   style={{display: 'table!important', border: 0}}>
                                <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>دانش‌آموز</th>
                                    <th>کدملی</th>
                                    <th>کلاس</th>
                                    <th>مبلغ شهریه</th>
                                    <th>مبلغ پرداختی</th>
                                    <th>مبلغ بدهی</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    (data.list === null ? [] : data.list).map((p, i) =>
                                        <tr key={"K39Erc1nSss" + i}>
                                            <td style={{width: '5%'}}>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td style={{width: '20%'}}>
                                                <Link to={`/admins/students/view/${p.id}`}>
                                                    {p.name}
                                                </Link>
                                            </td>
                                            <td style={{width: '10%'}}>{StringDigitsConvertToPersian(p.nationalCode)}</td>
                                            <td style={{width: '10%'}}>{p.class === '' ? 'نامشخص' : p.class}</td>
                                            <td style={{width: '15%'}}>
                                                <span>{CurrencyFormat(p.totalTuitionPrice)}<TomansIcon/></span>
                                            </td>
                                            <td style={{width: '15%'}}>
                                                <span>{CurrencyFormat(p.paidAmount)}<TomansIcon/></span>
                                            </td>
                                            <td style={{width: '15%'}}>
                                                <span>{CurrencyFormat(p.totalTuitionPrice - p.paidAmount)}<TomansIcon/></span>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : null
            }
            <SelectClassModal
                active={classModal}
                closeHandler={() => setClassModal(false)}
                onSelected={(id: number, title: string) => {
                    // ShowProgressLoading();
                    setClassSelected({
                        title: "کلاس " + title,
                        id: id,
                    });
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchList(id);
                }}
            />
        </>
    );
};